// extracted by mini-css-extract-plugin
module.exports = {"page_header":"PodPtsPage_page_header__qLM6B"};